import { STATUS_SALES_DOCUMENTS, TAB_SALES_DOCUMENTS } from 'components/pages/sales/base/enumsSales';
import { template } from 'utils/helper';

export const url_sales = {
	regenerate_pdf: template`sales-documents/regenerate-pdf/${'slug'}/`,
	download_pdf: template`sales-documents/download-pdf/${'slug'}/`,
	change_status: 'sales-documents/change-status/',
	create_sales_documents: 'sales-documents/create-sales-documents/',
	send_national_invoice_registry: template`/sales-documents/${'slug'}/send-national-invoice-registry/`,
	download_ksef_upo: template`/sales-documents/${'slug'}/download-official-receipt/`,
	object: template`sales-documents/${'slug'}/`,
	export: 'sales-documents/export/',
	list: 'sales-documents/',
	send_national_invoice_registry_all: 'sales-documents/send-national-invoice-registry-batch/'
};

const getParams = ({ page, rowsPerPage, sortParameter, isOrderByAsc, values, searchParameter }) => {
	const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;

	const pagination = Object.assign({},
		order && { o: order },
		rowsPerPage && { pageSize: rowsPerPage },
		page && { page: page + 1 }
	);

	const cpValues = { ...values };
	delete cpValues.month;
	delete cpValues.year;
	delete cpValues.isPaid;
	const formValues = Object.assign(cpValues,
		values?.month && { month: values?.month },
		values?.year && { year: values?.year }
	);

	const otherParams = Object.assign({},
		searchParameter && { q: searchParameter }
	);

	return {
		...pagination,
		...formValues,
		...otherParams
	};
};

// TODO: types
const sales = service => ({
	exportDocument: ({ startDate, endDate, statuses = [], saleTypes = [], exportType }) => {
		const params = Object.assign({},
			startDate && { startDate },
			endDate && { endDate },
			statuses.length && { statuses },
			saleTypes.length && { saleTypes },
			exportType && { exportType },
		);

		// Hot fix - form validation -> TODO: remove this (already handled in useData) and test
		const responseType = (startDate && endDate && statuses.length && saleTypes.length) ? 'blob' : null;
		return service.post(url_sales.export, params, {
			responseType
		});
	},
	regenerateDocument: ({ slug }) => service.get(url_sales.regenerate_pdf({ slug })),
	generatePdfDocument: ({ slug }) => service.get(url_sales.download_pdf({ slug }), {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		responseType: 'arraybuffer'
	}),
	getSalesDocuments: ({ page, rowsPerPage, sortParameter, isOrderByAsc, values, searchParameter, currentTab }) => {
		const tab = currentTab || TAB_SALES_DOCUMENTS.ALL;

		const filters = {
			[TAB_SALES_DOCUMENTS.ALL]: {},
			// [TAB_SALES_DOCUMENTS.NOT_PAID]: { status: STATUS_SALES_DOCUMENTS.IN_SETTLEMENT },
			[TAB_SALES_DOCUMENTS.GENERATED]: { status: STATUS_SALES_DOCUMENTS.GENERATED },
			[TAB_SALES_DOCUMENTS.CONFIRMED]: { status: STATUS_SALES_DOCUMENTS.REALIZED },
			[TAB_SALES_DOCUMENTS.BOOKED]: { status: STATUS_SALES_DOCUMENTS.BOOKED }
		};

		return service.get(url_sales.list, {
			params: {
				...getParams({ page, rowsPerPage, sortParameter, isOrderByAsc, values, searchParameter }),
				...filters[tab]
			}
		});
	},
	getSalesDocument: ({ slug }) => service.get(url_sales.object({ slug })),
	generateSalesDocuments: ({ values }) => service.post(url_sales.create_sales_documents, { ...values }),
	sendToNationalInvoiceRegistry: ({ slug }) => service.post(url_sales.send_national_invoice_registry({ slug })),
	downloadKsefUpo: (slug) => {
		const params = {};

		return service.get(url_sales.download_ksef_upo({ slug }), params, {
			responseType: 'blob'
		});
	},
	updateSalesDocument: ({ values, slug }) => {
		return service.patch(url_sales.object({ slug }), {
			...values
		});
	},
	changeStatus: ({ ids, paymentDate, status }) => service.put(url_sales.change_status, {
		salesDocuments: ids, paymentDate, status
	}),
	sendKsefAll: ({ ids }) => service.post(url_sales.send_national_invoice_registry_all, { slugs: ids })
});

export default sales;
